import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { ColorPickerPanel } from "./ColorPickerPanel";
import { useDesign } from "../state/designStore";

/** نافذة سفلية فيها المنتقي الاحترافي. */
export function ColorSheet({
  title,
  value,
  onChange,
  onClose,
}: {
  title: string;
  value: string;
  onChange: (hex: string) => void;
  onClose: () => void;
}) {
  const { setOverlayClose } = useDesign();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    setOverlayClose(() => onClose);
    return () => setOverlayClose(null);
  }, [onClose, setOverlayClose]);

  useEffect(() => {
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setShown(true)));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center" role="dialog" aria-modal="true">
      <div
        className="absolute inset-0 bg-black/60 transition-opacity duration-200"
        style={{ opacity: shown ? 1 : 0 }}
        onClick={onClose}
      />
      <div
        className="relative w-full max-w-md glass-card rounded-b-none max-h-[88vh] flex flex-col transition-transform duration-200 ease-out"
        style={{ transform: shown ? "translateY(0)" : "translateY(100%)" }}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 shrink-0">
          <h2 className="font-bold">{title}</h2>
          <button type="button" onClick={onClose} aria-label="إغلاق" className="w-8 h-8 flex items-center justify-center">
            <X size={18} />
          </button>
        </div>
        <div className="overflow-y-auto p-4">
          <ColorPickerPanel value={value} onChange={onChange} />
        </div>
        <div className="px-4 pb-4 pt-1 shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 rounded-2xl bg-tg-button text-tg-buttonText font-bold"
          >
            تم
          </button>
        </div>
      </div>
    </div>
  );
}

/** زر دائري بلون حالي، يفتح ColorSheet. rainbow = دائرة قوس قزح (بدون لون حالي). */
export function ColorSwatchButton({
  value,
  onChange,
  title,
  size = 44,
  rainbow = false,
}: {
  value: string;
  onChange: (hex: string) => void;
  title: string;
  size?: number;
  rainbow?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={title}
        className="rounded-full border-2 border-white/25 shrink-0 active:scale-95 transition-transform"
        style={{
          width: size,
          height: size,
          background: rainbow ? "conic-gradient(red, yellow, lime, cyan, blue, magenta, red)" : value,
        }}
      />
      {open && <ColorSheet title={title} value={value} onChange={onChange} onClose={() => setOpen(false)} />}
    </>
  );
}
